import React from 'react';

export default function PopupModal({ 
    popupContent, 
    setPopupContent, 
    data 
}) {

    return (
        <div className="popup-modal">
            <div className="popup-modal-wrapper">
                <div className="close-modal" onClick={() => setPopupContent(null)}>
                    <svg width="43" height="44" viewBox="0 0 43 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path id="Line 34" d="M31.8196 32.6706L10.6064 11.4574" stroke="#003FE2" strokeWidth="2"/>
                        <path id="Line 35" d="M31.8201 11.4573L10.6069 32.6705" stroke="#003FE2" strokeWidth="2"/>
                    </svg>
                </div>
                {data.footer_content && data.footer_content.map((item, index) => {
                    if (item.id === popupContent) {
                        return (
                            <div key={item.index + '.' + item.id} className="popup-modal-content">
                                <h1>{item.title}</h1>
                                <div className="popup-modal-inner-content">
                                    {item.contents.map((content, index) => {
                                        return (
                                            <>
                                                <h3 key={popupContent.index + '.' + index}>{content.title}</h3>
                                                <p key={index}>{content.content}</p>
                                            </>
                                        )
                                    })}
                                </div>
                            </div>
                        )
                    }
                })}
            </div>
        </div>
    )
}